export default "/images/vendor/flag-icon-css/flags/4x3/ag.svg?5929ca9ff0f160f96fb5ed45aa08fd12";